"use strict";

export default {
    "computed": {
        $_setStyle() {
            return this.$style[this.$store.getters.getConfigs.design.style];
        },
    },
};
